import React from "react";
import Button from "../../../../component/button/Button";
import { useSelector } from "react-redux";
import useClientConfig from "../../../../config/careers/clientConfig";


const OptionFourNoJob = (props: any) => {
    const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const {clientSiteSettings, clientAssetsLink} = useClientConfig();
    const noJobLang = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const noJobLangLabels = noJobLang?.noJobsSection?.[0];
    const { navigateToJob, navigateToJobAlerts, clientId } = props;
    

    return (
        (questionId?.status === 200  || cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1) ? (
            <div className={`job-search-box option_four_no_job_match_box ${(clientSiteSettings?.templateName === "template_9") ? "theme-new-page-id-2-banner " : null}`}>
                <div className="btn-section mt-3">
                    <div className="text-center">
                        <h2 className="job-view-text">{noJobLangLabels?.noJobs}</h2>
                        <p className="infi-text" dangerouslySetInnerHTML={{ __html: noJobLangLabels?.noJobsText }} ></p>
                        
                    </div>
                    <div className="filter-button-section">
                        {questionId?.status === 200 ?
                            <Button
                                clasName={`btn btn-primary completion-btn-primary register-interest ${(clientSiteSettings?.templateName !== "template_9") ? " w-100" : null}`}
                                label={cliendConfig?.data?.data?.clientSettings?.registerYourInterestButtonText || noJobLangLabels?.registerYourInterest}
                                iconImg={clientAssetsLink+"/Register.svg"}
                                onClick={navigateToJob}>
                            </Button>
                            : ""}
                        { (cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1) ? (
                            <Button
                                clasName={`btn btn-primary completion-btn-primary job-alerts ${(clientSiteSettings?.templateName !== "template_9") ? " w-100" : null}`}
                                label={cliendConfig?.data?.data?.clientSettings?.jobAlertButtonText || noJobLangLabels?.jobAlerts}
                                iconImg={clientAssetsLink+"/Alert.svg"}
                                onClick={navigateToJobAlerts}  />
                                
                        ) : null                     
                        }
                    </div>
                </div>
            </div>
        ) : ""
    );
};

export default OptionFourNoJob;